import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

import { isProductionMode } from 'src/js/utils';
import inx from 'inx';

const store = (set) => ({
    leftAsideVisible: false,
    updateCurrentFolder: false,
    labels: null,
    showLabels: false,
    toggleLeftAside: (visibility) => set((state) => {
        const newVisibility = visibility === undefined
            ? !state.leftAsideVisible
            : visibility;
        return { leftAsideVisible: newVisibility };
    }),
    updateFolder: () => set(
        (state) => ({ updateCurrentFolder: !state.updateCurrentFolder })
    ),
    setLabels: (obj) =>
        set(() => ({
            labels: obj,
        })),
    toggleLabels: (val) => set(
        (state) => {
            return { showLabels: typeof val === 'boolean' ? val : !state.showLabels };
        }
    ),
});

//this cody ic called also in separate link-proxy page. why?
const leftAsideStorageKey = `left-aside-store_${inx?.params?.user?.email}`;

// const useGlobalStore = create(store);
const persistentStore = persist(store, { name: leftAsideStorageKey });

const useStore = create(
    devtools(persistentStore, {
        enabled: !isProductionMode(),
        name: leftAsideStorageKey
    }),
);

export default useStore;
